// RF Admin 独立 router — 不挂在现有 AdminLayout 下
// 入口:`frontend/src/app/router.tsx` 通过单独 router 渲染 /rf-admin/*

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import { RfAdminLogin } from "./pages/RfAdminLogin";
import { RfAdminApp } from "./pages/RfAdminApp";
import { RfAdminTenants } from "./pages/RfAdminTenants";
import { RfAdminTenantNew } from "./pages/RfAdminTenantNew";
import { RfAdminTenantDetail } from "./pages/RfAdminTenantDetail";
import { RfAdminAdmins } from "./pages/RfAdminAdmins";
import { RfAdminMe } from "./pages/RfAdminMe";
import { rfAdminMe, type RfAdminUser } from "./api/client";

export function RfAdminRouter() {
  return (
    <Routes>
      <Route path="login" element={<RfAdminLogin />} />
      <Route element={<RfAdminGate />}>
        <Route index element={<Navigate to="tenants" replace />} />
        <Route path="tenants" element={<RfAdminTenants />} />
        <Route path="tenants/new" element={<RfAdminTenantNew />} />
        <Route path="tenants/:id" element={<RfAdminTenantDetail />} />
        <Route path="admins" element={<RfAdminAdmins />} />
        <Route path="me" element={<RfAdminMe />} />
      </Route>
      <Route path="*" element={<Navigate to="/rf-admin/login" replace />} />
    </Routes>
  );
}

// 已登录后,把所有 /rf-admin/* 页面套上 RfAdminApp(<Outlet/> 渲染子路由)。
function RfAdminGate() {
  const [admin, setAdmin] = useState<RfAdminUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    rfAdminMe().then((a) => {
      if (cancelled) return;
      setAdmin(a);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <div className="rf-admin-loading">読み込み中...</div>;
  }
  if (!admin) {
    window.location.replace(`/rf-admin/login`);
    return null;
  }
  return (
    <RfAdminApp admin={admin}>
      <Outlet />
    </RfAdminApp>
  );
}